import "./about.scss"

export default function About() {
    return (
        <div className="about" id="about">
            <h2>About me</h2>
           <div className="about-para"> 
           <h3>Hello, My name is Madhurima Banerjee. I am an aspiring Full-Stack Web Developer from Kolkata, West Bengal, India. Currently, I have done 7 months Full-Stack Web Development Course from Masai School.</h3>
            <h3>I am looking for a role in an
            enthusiastic work environment, to enhance the knowledge and
            skills learned and apply technical skills to accomplish
            organizational goals.</h3></div>
             <a href="https://drive.google.com/file/d/13bOGf9P72wXn6hq4FEaaqZGVq77LFg2D/view?usp=sharing" target="_blank" rel="noopener noreferrer"><button >Get Resume</button></a>
        </div>
    )
}
